import { render, staticRenderFns } from "./FactorClassScore.vue?vue&type=template&id=6e47efd9&scoped=true&"
import script from "./FactorClassScore.vue?vue&type=script&lang=ts&"
export * from "./FactorClassScore.vue?vue&type=script&lang=ts&"
import style0 from "./FactorClassScore.vue?vue&type=style&index=0&id=6e47efd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47efd9",
  null
  
)

export default component.exports